import { IntakeFormReservedFieldNames, ReservedFieldPropNames } from '@sweatpals/shared';

export const minFieldOptions = 2;
export const maxFieldOptions = 26;

export enum AttendeeRegistrationFieldTypeEnum {
	TextInput = 'text-input',
	RadioButtons = 'radio-buttons',
	CheckBox = 'check-box',
	CheckBoxList = 'checkbox-list',
	DropDown = 'drop-down',
	DatePicker = 'date-picker',
}

export const AttendeeRegistrationFieldTypeLabelEnum = {
	[AttendeeRegistrationFieldTypeEnum.TextInput]: 'Short Answer',
	[AttendeeRegistrationFieldTypeEnum.RadioButtons]: 'Single Choice',
	[AttendeeRegistrationFieldTypeEnum.CheckBox]: 'Single Checkbox',
	[AttendeeRegistrationFieldTypeEnum.CheckBoxList]: 'Multi Choice',
	[AttendeeRegistrationFieldTypeEnum.DropDown]: 'Dropdown Menu',
	[AttendeeRegistrationFieldTypeEnum.DatePicker]: 'Date and Time',
};

export const FieldTypeWithOptionsList = [
	AttendeeRegistrationFieldTypeEnum.DropDown,
	AttendeeRegistrationFieldTypeEnum.RadioButtons,
	AttendeeRegistrationFieldTypeEnum.CheckBoxList,
];

export const IntakeFormReservedFieldNamesToInputTypes: Record<IntakeFormReservedFieldNames, 'text-input'> = {
	[IntakeFormReservedFieldNames.FullName]: 'text-input',
	[IntakeFormReservedFieldNames.Email]: 'text-input',
	[IntakeFormReservedFieldNames.PhoneNumber]: 'text-input',
};

export const IntakeFormReservedFieldNamesToTextInputTypes: Record<
	IntakeFormReservedFieldNames,
	'text' | 'email' | 'phone-number'
> = {
	[IntakeFormReservedFieldNames.FullName]: 'text',
	[IntakeFormReservedFieldNames.Email]: 'email',
	[IntakeFormReservedFieldNames.PhoneNumber]: 'phone-number',
};

export const IntakeFormReservedFieldNamesToPlaceholder: Record<IntakeFormReservedFieldNames, string> = {
	[IntakeFormReservedFieldNames.FullName]: 'Full name',
	[IntakeFormReservedFieldNames.Email]: 'Email',
	[IntakeFormReservedFieldNames.PhoneNumber]: 'Phone Number',
};

export const IntakeFormReservedFieldNameToSettings: Record<
	IntakeFormReservedFieldNames,
	ReservedFieldPropNames
> = {
	[IntakeFormReservedFieldNames.FullName]: 'fullNameReservedField',
	[IntakeFormReservedFieldNames.Email]: 'emailReservedField',
	[IntakeFormReservedFieldNames.PhoneNumber]: 'phoneReservedField',
};
